import classNames from 'classnames';

import styles from './Slide.module.css';

export type SlideProps = JSX.IntrinsicElements['li'];

export function Slide({ children, className, ...props }: SlideProps) {
  return (
    <li className={classNames(styles.slide, className)} {...props}>
      {children}
    </li>
  );
}
